import { useEffect, useState } from "react";

import { BookingType } from "@/components/booking/types";
import {
  BookingFilterType,
  type CenterFragment,
  GetUseCentersDocument,
  type GetUseCentersQuery,
} from "@/generated/client.generated";
import { useLazyQuery } from "@apollo/client";

interface UseCentersProps {
  type?: BookingType;
}

function MapToFilterBookingType(bookingType?: BookingType): BookingFilterType {
  switch (bookingType) {
    case BookingType.GRUPPETIME:
      return BookingFilterType.Groupactivity;
    case BookingType.EVENTS:
      return BookingFilterType.Event;
    case BookingType.BARNEPASS:
      return BookingFilterType.ChildCare;
    case BookingType.CAGEBALL:
      return BookingFilterType.Cageball;
    case BookingType.GOLFSIMULATOR:
      return BookingFilterType.Golf;
    case BookingType.TRENINGSTESTER:
      return BookingFilterType.Measurement;
    case BookingType.SQUASH:
      return BookingFilterType.Squash;
    case BookingType.VEILEDNING:
      return BookingFilterType.Guidance;
    default:
      return BookingFilterType.Membership;
  }
}
export const useCentersSortedByDistance = ({ type }: UseCentersProps) => {
  const bookingFilterType = MapToFilterBookingType(type);
  const [askedForLocation, setAskedForLocation] = useState<boolean>(false);
  const [askedForLocationLoading, setAskedForLocationLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [centers, setCenters] = useState<ReadonlyArray<CenterFragment> | null>(null);

  const [getCenters] = useLazyQuery<GetUseCentersQuery>(GetUseCentersDocument, {
    variables: { bookingFilterType: bookingFilterType, lat: null, lon: null },
  });

  useEffect(() => {
    if (askedForLocation && navigator.geolocation) {
      setAskedForLocationLoading(true);
      setAskedForLocation(false);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          getCenters({
            variables: {
              bookingFilterType: bookingFilterType,
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            },
          }).then((response) => {
            const centers = response.data?.Centers;
            if (centers) {
              setCenters(centers);
              setAskedForLocationLoading(false);
              setErrorMessage(null);
            }
          });
        },
        () => {
          setAskedForLocationLoading(false);
          setErrorMessage("Godta stedstjenester i nettleseren din for å sortere listen");
        },
      );
    }
  }, [askedForLocation, getCenters, bookingFilterType, centers]);

  return { askedForLocation, askedForLocationLoading, centers, errorMessage, setAskedForLocation };
};
